import { Injectable } from "@angular/core";
import { LorenBaseEndpointsService } from "../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service";
import { LorenUtilsService } from "../../../../shared/services/loren-utils-service/loren-utils.service";
import { Instant } from "@js-joda/core";

@Injectable({
  providedIn: "root",
})
export class LorenAssetTraceEndpointsService extends LorenBaseEndpointsService {
  constructor() {
    super();
  }

   getAssetTraces(
    meteringId: number,
    fromDate: Instant,
    toDate: Instant,
    order: "asc" | "desc" = "asc",
    distance: number = null
  ) {
    // Millis are required by the back-end (we need to fix this there)
       let url = `${this.getApiServerUrl()}/assets/meterings/${meteringId}/track?dateFrom=${fromDate.plusMillis(1).toString()}&dateTo=${toDate.plusMillis(1).toString()}&order=${order}`;
    if (distance != null) {
      url += `&stops-distance-criteria=${distance}`;
    }

    return url;
  }

  exportTraceStopsDistanceSelectionReport(
    meteringIds,
    dateFrom,
    dateTo,
    stopDistanceCriteria
  ) {
    const assetIdsParam = LorenUtilsService.generateArrayToGETParams(
      "meteringIds",
      meteringIds
    );
    return `${this.getApiServerUrl()}/reports/tracking/export?dateFrom=${dateFrom}&dateTo=${dateTo}&${assetIdsParam}&stops-distance-criteria=${stopDistanceCriteria}`;
  }
}
